/** Stable answer map keys for survey parts (aligned with v1 payload keys). */

export function partAnswerKey(question, part) {
  const qtype = (question.type || "mcq").toLowerCase();
  const ptype = part.type;
  if (qtype === "text" && (!ptype || ptype === "")) {
    return `${question.id}-text`;
  }
  return `${question.id}-${ptype}`;
}
